import React from 'react';

import {Code, FlexView, Heading, Spacer} from '/component/base/Storybook';

import Icon from '../Icon';

export default () => (
  <>
    <Heading level={2}>System Icons</Heading>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="camera" />
        <Spacer size={6} />
        <Code>{'camera'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="certified" />
        <Spacer size={6} />
        <Code>{'certified'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="circle" />
        <Spacer size={6} />
        <Code>{'circle'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="circle-checkmark" />
        <Spacer size={6} />
        <Code>{'circle-checkmark'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="circle-checkmark-filled" />
        <Spacer size={6} />
        <Code>{'circle-checkmark-filled'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="email" />
        <Spacer size={6} />
        <Code>{'email'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="circle-filled" />
        <Spacer size={6} />
        <Code>{'circle-filled'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="radio" />
        <Spacer size={6} />
        <Code>{'radio'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="filter" />
        <Spacer size={6} />
        <Code>{'filter'}</Code>
        <Spacer size={16} />
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="help" />
        <Spacer size={6} />
        <Code>{'help'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="home" />
        <Spacer size={6} />
        <Code>{'home'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="id" />
        <Spacer size={6} />
        <Code>{'id'}</Code>
        <Spacer size={16} />
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="info" style={{color: '#878787'}} />
        <Spacer size={6} />
        <Code>{'info'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="learn" />
        <Spacer size={6} />
        <Code>{'learn'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="location" />
        <Spacer size={6} />
        <Code>{'location'}</Code>
        <Spacer size={16} />
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="logout" />
        <Spacer size={6} />
        <Code>{'logout'}</Code>
      </FlexView>
    </FlexView>
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="minus" />
        <Spacer size={6} />
        <Code>{'minus'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="notifications" />
        <Spacer size={6} />
        <Code>{'notifications'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="pay" />
        <Spacer size={6} />
        <Code>{'pay'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="phone" />
        <Spacer size={6} />
        <Code>{'phone'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="profile" />
        <Spacer size={6} />
        <Code>{'profile'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="renew" />
        <Spacer size={6} />
        <Code>{'renew'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="rewards" />
        <Spacer size={6} />
        <Code>{'rewards'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="search" />
        <Spacer size={6} />
        <Code>{'search'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="send" />
        <Spacer size={6} />
        <Code>{'send'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="settings" />
        <Spacer size={6} />
        <Code>{'settings'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="sort" />
        <Spacer size={6} />
        <Code>{'sort'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="sponsor" />
        <Spacer size={6} />
        <Code>{'sponsor'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="trash" />
        <Spacer size={6} />
        <Code>{'trash'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="tree-view" />
        <Spacer size={6} />
        <Code>{'tree-view'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="triangle" />
        <Spacer size={6} />
        <Code>{'triangle'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="megaphone" />
        <Spacer size={6} />
        <Code>{'megaphone'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="autorenew" />
        <Spacer size={6} />
        <Code>{'autorenew'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="lock" />
        <Spacer size={6} />
        <Code>{'lock'}</Code>
      </FlexView>
    </FlexView>
  </>
);
